import React, { useRef, useState } from 'react'

import s from './styles.module.scss'

import {
  HouseCorporateEveningIndividualForm,
  HouseCorporateEveningIndividualFormProps,
} from './components/corporate-evening/HouseCorporateEveningIndividualForm'
import {
  HouseNightlyTripIndividualForm,
  HouseNightlyTripIndividualFormProps,
} from './components/nightly-trip/HouseNightlyTripIndividualForm'
import {
  HouseStudyDayIndividualForm,
  HouseStudyDayIndividualFormProps,
} from './components/study-day/HouseStudyDayIndividualForm'
import {
  HouseOptionsFormLayoutProps,
  HouseOptionsFormProps,
} from '../HouseOptionsForm'
import {
  HouseSeasonalBusynessCalendarForm,
  HouseSeasonalBusynessCalendarFormProps,
} from '../shared/components/seasonal-busyness-calendar/HouseSeasonalBusynessCalendarForm'
import { HouseOptionsMenusEnum } from '../shared/types/house-options.types'
import { HousePriceTypeEnum } from '../../../../lib/graphql'

export type HouseOptionsIndividualFormProps =
  HouseSeasonalBusynessCalendarFormProps &
    HouseNightlyTripIndividualFormProps &
    HouseStudyDayIndividualFormProps &
    HouseCorporateEveningIndividualFormProps
export const HouseOptionsIndividualForm = ({
  house,
  isDisabled,
  updateStudyDayIndividual,
  updateNightlyTripIndividual,
  updateCorporateEveningIndividual,
  updateSeasonalBusynessCalendar,
}: HouseOptionsIndividualFormProps & HouseOptionsFormProps) => {
  const [openedCard, setOpenedCard] = useState<HouseOptionsMenusEnum | null>(
    HouseOptionsMenusEnum.SEASONAL_BUSYNESS_CALENDAR,
  )

  const refMenu = useRef<HTMLDivElement>(null)

  const handleOpenedCards = (card: HouseOptionsMenusEnum) => {
    setOpenedCard(openedCard === card ? null : card)
  }

  const formProps: Omit<
    HouseOptionsFormLayoutProps,
    'handleOnExpand' | 'isOpen'
  > = {
    house,
    isDisabled,
    layoutProps: {
      parentHeight: refMenu.current?.clientHeight,
      numberOfCards: house.priceType === HousePriceTypeEnum.INDIVIDUAL ? 6 : 5,
    },
  }

  return (
    <div className={s.containerHouseOptions} ref={refMenu}>
      <HouseSeasonalBusynessCalendarForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.SEASONAL_BUSYNESS_CALENDAR)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.SEASONAL_BUSYNESS_CALENDAR}
        updateSeasonalBusynessCalendar={updateSeasonalBusynessCalendar}
      />

      <HouseNightlyTripIndividualForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.NIGHTLY_TRIP)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.NIGHTLY_TRIP}
        updateNightlyTripIndividual={updateNightlyTripIndividual}
      />

      <HouseStudyDayIndividualForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.STUDY_DAY)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.STUDY_DAY}
        updateStudyDayIndividual={updateStudyDayIndividual}
      />

      <HouseCorporateEveningIndividualForm
        {...formProps}
        handleOnExpand={() =>
          handleOpenedCards(HouseOptionsMenusEnum.CORPORATE_EVENING)
        }
        isOpen={openedCard === HouseOptionsMenusEnum.CORPORATE_EVENING}
        updateCorporateEveningIndividual={updateCorporateEveningIndividual}
      />
    </div>
  )
}
